import { ApplicationState } from "../../ApplicationState";

export const unsubscribeResultSelector = (state: ApplicationState) => {
    return state.emailUnsubscribe.result;
};

export const unsubscribeLoadingSelector = (state: ApplicationState) => {
    return state.emailUnsubscribe.isLoading;
};